// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Modal from '../../_common/Modal';
import Card from '../Card';
import Cart, { itemTypes } from '../../_common/Cart';
import Col from '../../_common/form/Col';
import { generateId } from '../../_common/api/utility';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Button from '../../_common/form/Button';
import { HamQuest } from '../../../App';
import RequireFeature, { Features } from '../../_common/RequireFeature';

const AppCredit = ({ ...props }) => {
    const {
        state: {
            active_user
        },
    } = useGlobalState();

    const [giftCards, setGiftCards] = useState([]);

    useEffect(() => {
        HamQuest.get(QuestRoute.products.giftCards)
            .then((res) => {
                setGiftCards(res)
            })
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to get App Credit Options',
                    body: 'Sorry, something went wrong. Please try again.'
                })
            })
    }, [])

    return (
        <RequireFeature requiredFeatures={Features.AppCredit}>
            <Col>
                <Card icon='creditCard' title='App Credit' />

                {giftCards
                    .filter(e => e.productType === itemTypes.eGiftCard)
                    .sort((a, b) => b.price - a.price)
                    .map((e, i) => (
                        <Card key={`${i}-itemCard`} title={e.name}>
                            <span>Price: ${e.price}</span>
                            {e.value && <span>You get a value of: ${e.value}</span>}
                            {e.details?.map(e => <p key={generateId()}>{e}</p>)}
                            {active_user.isLoggedIn &&
                                <Button onClick={() => Cart.BuyNow(e, false)}>Buy Now!</Button>
                            }
                        </Card>
                    ))
                }
            </Col>
        </RequireFeature>
    );
}

export default AppCredit;
